import { useState } from "react";
import { connect, useDispatch } from "react-redux";
import {
  Card,
  CardHeader,
  CardMedia,
  CardContent,
  Typography,
  CardActions,
  Button,
  Tooltip,
} from "@mui/material";
import { useHistory } from "react-router-dom";
import StarIcon from "@mui/icons-material/Star";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import {
  getNovedadesMenuByClienteId,
  marcarNovedadComoLeida,
} from "../../actions/novedades";
import "./novedad.css";

const Novedad = (props) => {
  const localSessionItem = window.localStorage.getItem("LocalSession");
  const local = localSessionItem ? JSON.parse(localSessionItem) : null;

  const [isHovered, setIsHovered] = useState(false);
  const [leido, setLeido] = useState(props.data.leido);

  const history = useHistory();

  const dispatch = useDispatch();

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  const verMas = () => {
    setLeido(true);
    dispatch(
      marcarNovedadComoLeida({
        clienteId: local.clienteId.trim(),
        contactoId: local.contactoId,
        novedadId: props.data.id,
      }),
    );

    localStorage.setItem("novedadData", JSON.stringify(props.data));
    history.push(`/novedad/${props.data.id}`);
  };

  return (
    <Card
      onClick={verMas}
      style={{
        width: 358,
        maxWidth: 360,
        height: 530,
        margin: "6vh 2vh 2vh 2vh",
        backgroundColor: isHovered ? "rgba(255, 0, 0, 0.8)" : "#f5f0f0",
        borderLeft: !props.data.leido && !isHovered ? "4px solid red" : "none",
        position: "relative",
      }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {!props.data.leido && (
        <div
          style={{
            position: "absolute",
            top: "10px",
            left: "10px",
            backgroundColor: "red",
            color: "white",
            borderRadius: "12px",
            padding: "2px 10px",
            fontSize: "0.7rem",
            fontWeight: "bold",
            zIndex: 1,
          }}
        >
          NUEVO
        </div>
      )}

      {props.data.link !== "" && (
        <CardMedia
          component="img"
          height={180}
          image={props.data?.link}
          alt="imagen_novedad"
        />
      )}
      <CardHeader
        style={{ height: "140px", padding: "1vw" }}
        action={
          props.data?.destacada && (
            <Tooltip title="Destacada">
              <div aria-label="settings">
                <StarIcon />
              </div>
            </Tooltip>
          )
        }
        titleTypographyProps={{
          fontSize: "0.7rem",
          fontWeight: "bold",
          style: {
            color: isHovered ? "white" : "inherit",
            marginBottom: "1vh",
          },
        }}
        subheaderTypographyProps={{
          variant: "h6",
          fontWeight: "bold",
          style: {
            fontWeight: !props.data.leido ? "800" : "bold",
            color: isHovered ? "white" : "inherit",
          },
        }}
        title={props.data?.fechaCreacion}
        subheader={props.data?.titulo}
      />
      <CardContent style={{ height: "140px", padding: "0vw 2vw 2vw 2vw" }}>
        <Typography
          variant="body1"
          color="text.secondary"
          style={{ color: isHovered ? "white" : "inherit" }}
          sx={{
            fontSize: "0.9rem",
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: "6",
            WebkitBoxOrient: "vertical",
          }}
        >
          {props.data?.textoPortada}
        </Typography>
      </CardContent>
      <CardActions style={{ height: "70px" }}>
        <Button
          style={{ color: isHovered ? "white" : "red", marginLeft: "1vw" }}
          onClick={verMas}
          endIcon={<ArrowForwardIcon />}
        >
          VER MÁS
        </Button>
      </CardActions>
    </Card>
  );
};

export default connect(
  (state) => ({
    loading: state.novedades.loading,
  }),
  (dispatch) => ({
    getNovedadesMenuByClienteId: (clienteId, contactoId) =>
      dispatch(getNovedadesMenuByClienteId(clienteId, contactoId)),
    marcarNovedadComoLeida: (clienteId, contactoId, novedadId) =>
      dispatch(marcarNovedadComoLeida({ clienteId, contactoId, novedadId })),
  }),
)(Novedad);
